import React, { MouseEventHandler } from "react";
import "../../css/testCenter.css";
import { Button } from "antd";

interface CameraPermissionDescriptionType {
  onCloseDescriptionModal: MouseEventHandler<HTMLElement>;
}

function CameraPermissionDescription(props: CameraPermissionDescriptionType) {
  const { onCloseDescriptionModal } = props;

  return (
    <div className="test_center__content" style={{ marginTop: "30px" }}>
      <div className="test_description_card_content_wrapper">
        <div className="test_description_card_content">
          <div className="test_description_card_content_text">
            <div style={{ marginBottom: "30px" }}>
              <text style={{ color: "grey", fontWeight: "500" }}>
                Camera permission is required to continue the test. Please allow
                camera access and reload the page to start the test again.
              </text>
            </div>
          </div>

          <div className="start_test_btn">
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              onClick={onCloseDescriptionModal}
            >
              Got it!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CameraPermissionDescription;
